import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Alert } from 'react-bootstrap'
import {
	getErrorWithFullMessage,
	downloadBlob,
	customerDataApiService,
	IDocuments,
	DocumentTypes,
} from 'exports'
import { useTranslation } from 'react-i18next'

interface IDownloadRepaymentButton {
	style: any
	styleHover: any
	icon: any
	repaymentPlanId?: string
	documentInfo?: IDocuments
}

function DownloadLoanDocumentButton({
	style,
	styleHover,
	icon,
	repaymentPlanId,
	documentInfo,
}: IDownloadRepaymentButton) {
	const [hover, setHover] = useState(false)
	const [loading, setLoading] = useState(false)
	const [error, setError] = React.useState<Error>()
	const { t } = useTranslation()

	const options = {
		rp: {
			buttonText: () => t('DownloadRepaymentPlan'),
			download: () => downloadSignedDocument(),
		},
		pn: {
			buttonText: () => t('DownloadSignedPromissoryNote'),
			download: () => downloadPnDocument(),
		},
	}
	const [opt] = useState(options[repaymentPlanId ? 'rp' : 'pn'])

	function toggleHover() {
		setHover(!hover)
	}

	function setFullError(e: Error) {
		setError(getErrorWithFullMessage(e))
	}

	async function downloadSignedDocument() {
		try {
			setLoading(true)
			if (!repaymentPlanId && repaymentPlanId === '') {
				return
			}

			const blob = await customerDataApiService.getSignedDocument(
				repaymentPlanId!,
				t,
			)
			const fileName = 'RepaymentPlan-' + repaymentPlanId + '.pdf'

			setLoading(false)
			downloadBlob(blob, fileName)
		} catch (error: any) {
			setLoading(false)
			setFullError(error)
		}
	}

	// This combines dwonloading both signed PN and "normal" PN. Should be fixed to be a bit nicer at some point.
	async function downloadPnDocument() {
		try {
			setLoading(true)
			if (!documentInfo) {
				return
			}
			const blob = await customerDataApiService.getDownloadDocumentById(
				documentInfo!.documentId.toString(),
			)

			let fileName = documentInfo?.fileName

			if (!fileName) {
				fileName =
					documentInfo.type === DocumentTypes.SignedPromissoryNote
						? 'SignedPN-' + documentInfo?.documentId + '.asice'
						: 'PN-' + documentInfo?.documentId + '.pdf'
			}

			setLoading(false)
			downloadBlob(blob.blob, fileName)
		} catch (error) {
			setLoading(false)
			setFullError(new Error(t('DownloadError')))
		}
	}

	return (
		<div className="downloadRepaymentPlanButton">
			{error ? (
				<Alert
					variant="danger"
					dismissible
					onClose={() => setError(undefined)}>
					{error.message}
				</Alert>
			) : (
				<button
					onMouseEnter={toggleHover}
					onMouseLeave={toggleHover}
					onClick={(event: any) => {
						opt.download()
					}}
					style={hover ? styleHover : style}>
					<FontAwesomeIcon
						className={!loading ? 'mr-2' : 'hidden'}
						icon={icon}
					/>
					{loading ? (
						<span className="btnLoading"></span>
					) : (
						<span>{opt.buttonText()}</span>
					)}
				</button>
			)}
		</div>
	)
}

export default DownloadLoanDocumentButton

